import { forwardRef } from "react";
import { subtypeOf, useDrawing, specOf } from "@/lib/iwin";
import { SheetFrame, F } from "@/components/sheets/SheetFrame";

const X = 12, Y = 30, W = 286, H = W * 297 / 420;

const Spec = ({ s, item }) => {
  const sp = specOf(s, item), wl = String(item.wind_load || Object.keys(s.limits)[0]), l = s.limits[wl] || {};
  const rows = [
    ["Product", s.name], ["Frame / sash depth", `${sp.frame_depth} mm${item.flyscreen ? " (with flyscreen)" : ""}`], ["Frame joint", s.joint],
    ["Glass groove", "SGU 18 mm (5/6/8/10) · DGU 32 mm (22/23/24/26)"], ["Max sash load", `${s.max_leaf_kg} kg/leaf`],
    ["Interlock", item.interlock ? `${item.interlock}-type` : "—"], [`Size limit @ ${wl} Pa`, (l.wmax || l.hmax ? `W ${l.wmin ? `${l.wmin}–` : "max "}${l.wmax || "—"} · H ${l.hmin ? `${l.hmin}–` : "max "}${l.hmax || "—"}${s.per_leaf ? " per leaf" : ""}` : "Refer to official size-limitation chart")],
    ...(item.railing?.height ? [["Integrated railing", `${item.railing.height} mm above sill`]] : []),
  ];
  return rows.map(([k, v], i) => (
    <g key={k}>
      <text x={X + (i % 2) * 143} y={Y + H + 9 + Math.floor(i / 2) * 9} fontSize={2.2} fill="#555" fontFamily={F}>{k.toUpperCase()}</text>
      <text x={X + (i % 2) * 143} y={Y + H + 13 + Math.floor(i / 2) * 9} fontSize={3} fill="#000" fontFamily={F}>{String(v).slice(0, 62)}</text>
    </g>
  ));
};

export const OfficialSheet = forwardRef(({ item, tb, sheetNo, total }, ref) => {
  const s = subtypeOf(item);
  const src = useDrawing(s);
  return (
    <SheetFrame svgRef={ref} item={item} tb={tb} sheetNo={sheetNo} total={total} suffix="O" kind="OFFICIAL IWIN-S SECTION DRAWING"
      title="SECTION DRAWING (OFFICIAL IWIN-S)" subtitle={s ? `BHORUKA EXTRUSIONS · A YKK AP COMPANY · ${s.name.toUpperCase()}` : "NO IWIN-S PRODUCT SELECTED"} scaleText="AS PLOTTED">
      <rect x={X} y={Y} width={W} height={H} fill="none" stroke="#000" strokeWidth={0.25} />
      {s && src && <image href={src} xlinkHref={src} x={X} y={Y} width={W} height={H} preserveAspectRatio="xMidYMid meet" data-testid="official-drawing-image" />}
      {s && !src && <text x={X + W / 2} y={Y + H / 2} fontSize={4} fill="#999" fontFamily={F} textAnchor="middle">Loading official drawing…</text>}
      {!s && <text x={X + W / 2} y={Y + H / 2} fontSize={4} fill="#999" fontFamily={F} textAnchor="middle">Select an IWIN-S product in Geometry › IWIN-S product</text>}
      {s && <Spec s={s} item={item} />}
      <text x={16} y={284.5} fontSize={2} fontFamily={F} fill="#555">Official section drawing reproduced from bhorukaextrusions.com. Dimensions in mm. Verify with the latest Bhoruka / YKK AP technical documents.</text>
    </SheetFrame>
  );
});
OfficialSheet.displayName = "OfficialSheet";
